import _e from 'common/localeUtil';

export const processHandleSubmitResponse = (response) => {
	console.log(response);
	if (response instanceof Promise) {
		return response;
	}

	return Promise.reject(response);
};

export const handleServerErrorMessage = (error) => {
	console.log(error);
	if (typeof error === 'string') {
		return _e(error, {}, error);
	}
	if (error) {
		const { key, param } = error;
		return _e(key, param, key);
	}
	return null;
};

export const handleError = (error) => {
	if (error.error) {
		const formError = error.error;
		delete error.error;
		const translatedError = _e(formError, {}, formError);
		error._error = translatedError;
	}
	return error;
};
export const formatFieldErrors = (error, label, index) => {
	if (error) {
		const { exception, field_errors: fieldErrors } = error;
		if (exception && fieldErrors) {
			if (label) {
				console.log(label, index, fieldErrors);
				const mappedFieldErrors = {};
				mappedFieldErrors[label] = {
					[index]: fieldErrors,
				};
				return mappedFieldErrors;
			}

			return fieldErrors;
		}
	}

	return null;
};
export const formatServerError = (error) => {
	if (error) {
		console.log(error);
		const { exception, non_field_errors: nonFieldErrors } = error;
		console.log(exception, nonFieldErrors);
		if (exception) {
			console.log(nonFieldErrors);
			return nonFieldErrors ? _e(nonFieldErrors, { html: true }, nonFieldErrors) : null;
		}
	}

	return null;
};

export const handleFieldOrServerError = (errorObject, showSnackbar) => {
	const errorMessage = errorObject?.payload?.message?.data;
	if (errorMessage) {
		const nonFieldError = formatServerError(errorMessage);
		if (nonFieldError) {
			showSnackbar && showSnackbar(nonFieldError, 'error');
		}
		const fieldErrors = formatFieldErrors(errorMessage);
		if (fieldErrors) {
			showSnackbar && showSnackbar(_e('common.pls_fix_error_msg'), 'error');
			throw new Error(fieldErrors);
		}
	}
};

export const handleFieldOrServerErrorDisplayErrors = (errorObject, showSnackbar) => {
	const errorMessage = errorObject?.payload?.message?.data;
	if (errorMessage) {
		const nonFieldError = formatServerError(errorMessage);
		if (nonFieldError) {
			showSnackbar && showSnackbar(nonFieldError, 'error');
		}
		const fieldErrors = formatFieldErrors(errorMessage);
		if (fieldErrors) {
			showSnackbar &&
				showSnackbar(
					_e('common.form_submit_error_msg', {
						error_msg: fieldErrors,
					}),
					'error',
				);
			throw new Error(fieldErrors);
		}
	}
};

const mapArrayOrKey = (firstKey) => {
	if (window.isNaN(firstKey)) return firstKey;
	return `[${firstKey}]`;
};
export const getElementName = (error) => {
	if (typeof error === 'object') {
		const keys = Object.keys(error);
		if (keys && keys.length > 0) {
			const firstKey = keys[0];
			const firstValue = error[firstKey];
			const nextKey = getElementName(firstValue);
			const theFirstKey = mapArrayOrKey(firstKey);
			const isArray = nextKey && nextKey.startsWith('[');
			return `${theFirstKey}${nextKey ? `${isArray ? '' : '.'}${nextKey}` : ''}`;
		}
		return null;
	}
	return null;
};
